import React from 'react';

export const Privacy = () => {
  return (
    <div className="page-legal">
      <div className="container">
        <h1 className="heading-1">Politique de confidentialité</h1>
        
        <section className="legal-section">
          <h2 className="heading-2">1. Introduction</h2>
          <p className="body-medium">
            La présente politique de confidentialité explique comment Réseau d'Aide à Domicile 
            collecte, utilise et protège vos données personnelles conformément au Règlement 
            Général sur la Protection des Données (RGPD).
          </p>
        </section>

        <section className="legal-section">
          <h2 className="heading-2">2. Données collectées</h2>
          <p className="body-medium">Nous collectons les données suivantes :</p>
          <ul className="legal-list">
            <li>Nom et prénom</li>
            <li>Adresse email</li>
            <li>Numéro de téléphone</li>
            <li>Adresse postale</li>
            <li>Informations relatives aux services demandés</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2 className="heading-2">3. Utilisation des données</h2>
          <p className="body-medium">Vos données sont utilisées pour :</p>
          <ul className="legal-list">
            <li>Répondre à vos demandes de devis</li>
            <li>Fournir nos services</li>
            <li>Vous contacter concernant nos prestations</li>
            <li>Améliorer la qualité de nos services</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2 className="heading-2">4. Protection des données</h2>
          <p className="body-medium">
            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles 
            appropriées pour protéger vos données personnelles contre tout accès, modification, 
            divulgation ou destruction non autorisés.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="heading-2">5. Vos droits</h2>
          <p className="body-medium">Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul className="legal-list">
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification</li>
            <li>Droit à l'effacement</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité des données</li>
            <li>Droit d'opposition</li>
          </ul>
          <p className="body-medium">
            Pour exercer ces droits, contactez-nous à : contact@reseaudaideadomicile.fr
          </p>
        </section>

        <section className="legal-section">
          <h2 className="heading-2">6. Conservation des données</h2>
          <p className="body-medium">
            Vos données personnelles sont conservées pendant la durée nécessaire aux finalités 
            pour lesquelles elles ont été collectées, conformément aux obligations légales.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="heading-2">7. Contact</h2>
          <p className="body-medium">
            Pour toute question concernant cette politique de confidentialité, contactez-nous :
          </p>
          <ul className="legal-list">
            <li>Email : contact@reseaudaideadomicile.fr</li>
            <li>Téléphone : 04 81 11 95 91</li>
            <li>Adresse : 23 rue du Dauphiné, 69003 Lyon</li>
          </ul>
        </section>

        <p className="body-medium" style={{ marginTop: '32px', fontStyle: 'italic' }}>
          Dernière mise à jour : Janvier 2025
        </p>
      </div>
    </div>
  );
};